module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/question-labels-edit/question-labels-edit.component.scss
// module id = ./src/app/admin/question-labels-edit/question-labels-edit.component.scss
// module chunks = main